module.exports = __webpack_public_path__ + "static/media/mtu.6d95ff93.jpeg";